import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';
import router from '@/router';
import { mapActions } from 'vuex';
import Modal from '@/components/Partials/Modal.vue';

export default {
    name: 'newPromotionHall',

    data(){
        return {
            promotionType: 2, // Hall is type 2
            potentialTeamMates: [],
            teamMates: [],
            promotionSample: 1,
            imageId: null,
            showLoader: false,
            showModal: false,
        };
    },

    components: {
        BaseLayout,
        Modal,
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),
        /**
         * Remove coworker from this team
         * @param username
         */
        removeMate(username) {
            this.teamMates = this.teamMates.filter((mate) => {
                return mate.username !== username;
            })
        },

        /**
         * Add user to team mates
         *
         * @param id
         * @param username
         */
        addToTeamMates(id, username) {
            this.potentialTeamMates = this.potentialTeamMates.filter((mate) => {
                return mate.username !== username;
            })
            this.teamMates.push({id, username});
        },

        /**
         * Search new coworker from backend for this team
         * @param event
         */
        searchNewTeamMate(event) {
            if (event.target.value == '') {
                return;
            }
            const params = new URLSearchParams();
            params.append('username', event.target.value);
            api.post('/api/promoters_search', params)
                .then((response) => {
                    this.potentialTeamMates = response.data.body.entries;
                })
                .catch((error) => {
                    //commit('SHOW_LOGIN_ERRORS', error.response.data);
                });
        },

        /**
         * Set image in data object when user upload image
         * @param event
         */
        uploadImage(event) {
            this.showLoader = true;
            let formData = new FormData();
            formData.append('file', event.target.files[0])
            api.post('/api/assets', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    this.imageId = response.data.body.entry.id;
                    this.showLoader = false;
                })
                .catch((error) => {
                    this.showLoader = false;
                });
        },

        /**
         * Clear search input
         */
        clearSearchTerm() {
            this.$refs['searchTerm'].value = '';
            this.potentialTeamMates = [];
        },

        /**
         * Send to server new created promotion
         */
        submitCreatePromotion: function () {
            const params = new FormData();
            for(let promoter of this.teamMates){
                params.append('additional_promoters[]', promoter.id);
            }
            params.append('type', this.promotionType);
            params.append('promotion_with_samples', 0);
            params.append('promotion_stand', this.imageId);
            params.append('promotion_with_gifts', Number(this.promotionSample) === 1 ? 1 : 0);

            api.post(`/api/promotions_start/${this.$route.params.id}`, params)
                .then(() => {
                    this.storePromotion();
                    router.replace('/promotion')
                })
                .catch((error) => {
                });
        },

        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    },
}